module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9voW2"))).then(() => parcelRequire('1oyy4'));